import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import moment from 'moment'
import {DatePicker} from 'antd'

@inject('store') @observer
class End extends Component {
  handleChange = (date, dateString) => {
    const {backtest, permissions} = this.props.store
    const {start} = backtest.single.data
    if (moment(dateString).subtract(365, 'days') > moment(start)) {
      permissions.wrap('lab.five_years_range.use', () => backtest.single.change('end', dateString))
    } else {
      backtest.single.change('end', dateString)
    }
  }
  disabledDate = (date) => {
    const {backtest} = this.props.store
    const {start} = backtest.single.data
    return date < moment(start)
  }
  dateRender = (current) => {
    const {backtest, permissions} = this.props.store
    const {start} = backtest.single.data
    let style = {}
    if (
      !permissions.check('lab.five_years_range.use') &&
      current > moment(start).add(365, 'days')
    ) {
      style = {
        background: '#f5f5f5',
        color: '#bcbcbc',
        borderRadius: 0,
        width: 'auto',
        border: '1px solid transparent'
      }
    }
    return(
      <div className='ant-calendar-date' style={style}>
        {current.date()}
      </div>
    )
  }
  render() {
    const {backtest} = this.props.store
    const {end} = backtest.single.data
    return(
      <div>
        <label>End Date</label>
        <DatePicker
          value={moment(end).isValid() ? moment(end) : null}
          onChange={this.handleChange}
          disabledDate={this.disabledDate}
          dateRender={this.dateRender}
          placeholder='Select Date'
          allowClear={false}
          size='large'
        />
      </div>
    )
  }
}

export default End
